<template>
  <section>
    <nav class="navbar" ref="navbar">
      <div class="container">
        <ul class="trigger">
          <li>
            <a href="mailto:bkirvin@gmail.com"><i class="material-icons">email</i></a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/bryankirvin"><i class="material-icons">public</i></a>
          </li>
          <li @click="showSidebar = !showSidebar">
            <i class="material-icons">menu</i>
          </li>
        </ul>
        <div>
          <router-link :to="{ name: 'Home' }">
            <img src="@/assets/logos/newlogo.png" alt="logo" class="logo" />
          </router-link>
          <ul class="right hide-on-med-and-down">
            <li>
              <router-link :to="{ name: 'Snap' }">
                <img src="@/assets/buttons/snap.jpg" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Beep' }">
                <img src="@/assets/buttons/beep-icon.jpg" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Lazer' }">
                <img src="@/assets/buttons/lazerball.jpg" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Jack' }">
                <img src="@/assets/buttons/jack.jpg" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Loons' }">
                <img src="@/assets/buttons/jackaloons.jpg" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Dloons' }">
                <img src="@/assets/buttons/doubloons-icon.png" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Bumble' }">
                <img src="@/assets/buttons/bumbleme.jpg" :style="barHeight" alt />
              </router-link>
            </li>
          </ul>
          <ul v-if="showSidebar" id="mobile" class="sidebar" @click="showSidebar = !showSidebar">
            <li>
              <router-link :to="{ name: 'Home' }" >
                <i class="material-icons">home</i>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Snap' }">
                <img src="@/assets/buttons/snap.jpg" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Beep' }">
                <img src="@/assets/buttons/beep-icon.jpg" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Lazer' }">
                <img src="@/assets/buttons/lazerball.jpg" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Jack' }">
                <img src="@/assets/buttons/jack.jpg" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Loons' }">
                <img src="@/assets/buttons/jackaloons.jpg" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Dloons' }">
                <img src="@/assets/buttons/doubloons-icon.png" :style="barHeight" alt />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Bumble' }">
                <img src="@/assets/buttons/bumbleme.jpg" :style="barHeight" alt />
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Navbar',
  data () {
    return {
      showSidebar: false
    }
  },
  computed: {
    ...mapState([
      'navHeight'
    ]),
    barHeight () {
      return {
        height: this.navHeight + 'px'
      }
    }
  },
  methods: {
    ...mapActions([
      'setNavHeight'
    ])
  },
  watch: {
    $route (to, from) {
      window.scrollTo(0, 0)
    }
  },
  mounted () {
    this.setNavHeight(parseInt(this.$refs.navbar.clientHeight * 0.9))
  }
}
</script>

<style>
nav {
  background-color: black;
}
a {
  display: inline-block;
}
.container {
  width: unset !important;
}
li {
  margin-top: 5px;
}
#mobile {
  position: absolute;
  right: 0;
  width: 90px;
  background-color: #555;
}
.sidebar li>a {
  margin-bottom: 20px;
}

.sidebar li>a>i {
  margin-right: 0;
  color: white;
  font-size: 4rem;
}
li>a>img:hover {
  box-shadow: -1px 1px 15px white;
  border: 1px solid black;
}
router-link>i {
  font-size: 4rem;
  color: white;
}

.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: rgb(31, 41, 18);
  color: #ffd180;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  outline: 0;
  z-index: 100;
}
nav .trigger {
  float: right !important;
}

.logo {
  position: absolute;
  top: 0;
  left: 0;
  width: 40%;
  max-width: 300px;
}
.trigger li:nth-child(3) {
    display: none;
  }

@media only screen and (max-width: 992px) {
  .trigger li:nth-child(3) {
    display: block;
  }
}
</style>
